




























































































import {
  mdiHeadset,
  mdiAccountMultiple,
  mdiPhone,
  mdiSitemap,
  mdiEmail,
} from "@mdi/js";
import { Component, Mixins } from "vue-property-decorator";
import LanguageChanger from "@/components/utility/LanguageChanger.vue";
import IconItem from "@/components/ui/IconItem.vue";
import { LinkMixin } from "@/mixins/LinkMixin";
import QuestionnaireDialog from "@/views/App/AppQuestionnaire.vue";

@Component({
  components: { LanguageChanger, IconItem, QuestionnaireDialog },
})
export default class AppHeader extends Mixins(LinkMixin) {
  mdiHeadset = mdiHeadset;
  mdiAccountMultiple = mdiAccountMultiple;
  mdiPhone = mdiPhone;
  mdiSitemap = mdiSitemap;
  mdiEmail = mdiEmail;

  get isKz() {
    return this.$i18n.locale != "ru";
  }

  get locale() {
    return !this.isKz ? "ru" : "kz";
  }

  get contactLink() {
    return !this.isKz
      ? "https://esalmaty.kz/ru/contact/contact-center"
      : "https://esalmaty.kz/kz/contact-center";
  }

  // instagramSvg = require("@/assets/insta.svg");
  // facebookSvg = require("@/assets/facebook.svg");
  // telegramSvg = require("@/assets/telegram.svg");

  get logoMaxWidth() {
    switch (this.$vuetify.breakpoint.name) {
      case "sm":
      case "md":
      case "lg":
      case "xl":
        return "250px";
      case "xs":
      default:
        return "180px";
    }
  }
}
